import { Modal, ModalBody, ModalDialog, ModalHeader, ModalTitle } from '@ax/ui';

export interface HSInvalidFormModalProps {
  modalOpen?: boolean;
  modalClose?: () => void;
}

export const HSInvalidFormModal = ({ modalOpen = false, modalClose }: HSInvalidFormModalProps) => {
  const handleModalClose = () => modalClose?.();

  return (
    <Modal onShow={modalOpen}>
      <ModalDialog>
        <ModalHeader onHide={handleModalClose}>
          <ModalTitle>Complete Required Fields</ModalTitle>
        </ModalHeader>
        <ModalBody>
          Please add input to all required fields (*) in order to upload to EMR.
        </ModalBody>
      </ModalDialog>
    </Modal>
  );
};
